import { updateSelectedVehicle } from "api/garage/updateSelectedVehicle";
import { RootState } from "interfaces/generics.type";
import { IVehicle } from "interfaces/session/IVehicle";
import { Dispatch } from "redux";
import { validateVehicle } from "util/vehicle/validate-vehicle";
import { IGetAllVehiclesAction } from "../interfaces/garage.interface";

export function selectVehicle(vehicle: IVehicle | null, skipAPICall = false): ((dispatch: Dispatch<IGetAllVehiclesAction, RootState>) => void) {
  return (dispatch: Dispatch<IGetAllVehiclesAction, RootState>) => {
    if (validateVehicle(vehicle) && !(["number", "string"].includes(typeof vehicle.year))) {
    }
    if (!skipAPICall) {
      updateSelectedVehicle(vehicle)
        .then(({ data }) => {
          if (data.success) {
            const updatedYear = ["number", "string"].includes(typeof data.year) ? data.year.toString() : "";
            // fitment option can also contain some other params like selectedDateTime, that should not be added to vehicle
            const cleanFitmentOptions = data.fitmentOptions?.map((fo) => ({
              optionName: fo.optionName,
              optionValue: fo.optionValue,
            }));
            const updatedVehicle: IVehicle = {
              make: data.make,
              model: data.model,
              year: updatedYear,
              fitmentOptions: cleanFitmentOptions,
              colorData: data.colorData,
            };
            dispatch({ type: "SELECT_VEHICLE", data: updatedVehicle });
          } else {
          }
        });
    }
    const updatedYear = ["number", "string"].includes(typeof vehicle?.year) ? vehicle?.year.toString() : "";
    dispatch({
      type: "SELECT_VEHICLE",
      data: { ...vehicle, year: updatedYear },
    });
  };
}
